enum AgeGroups {
  ALL = "ALL",
  U12 = "U12",
  U16 = "U16",
  U21 = "U21",
  SENIOR = "SENIOR",
}

export default AgeGroups;
